import React, { FunctionComponent, useContext } from "react";
import { Theme, makeStyles, Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { UserDataContext } from "../context/user-data-context";
import { PresentationTextField } from "../../components/presentation-textfield";
import { PrimaryButton } from "../../../../../components/buttons/primary-button";

const useStyles = makeStyles((theme: Theme) => ({
  changePasswordButton: {
    marginTop: theme.spacing(3),
  },
}));

interface IUserDataAccountInfoProps {
  onChangePassword: () => void;
}

export const UserDataAccountInfo: FunctionComponent<IUserDataAccountInfoProps> = (props) => {
  const { onChangePassword } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const { email } = useContext(UserDataContext);
  return (
    <Grid container item xs={12} justify="space-between" alignItems="flex-end">
      <Grid item xs={12} sm={6}>
        <PresentationTextField fullWidth label={t("user_data.info.account_info.email")} value={email} autoFocus />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Grid container justify={"center"}>
          <PrimaryButton className={classes.changePasswordButton} onClick={onChangePassword}>
            {t("user_data.info.account_info.change_password_button")}
          </PrimaryButton>
        </Grid>
      </Grid>
    </Grid>
  );
};
